import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";

export default function DashboardLayout() {
    const { pathname } = useLocation();
    // LOT 52 — Scoped full-width : edge-to-edge sur la vue Dossier ; conteneur centré ailleurs.
    const fullWidth = pathname.startsWith("/dossiers/");
    return (
        <div
            data-testid="dashboard-layout"
            className="min-h-screen flex bg-background text-foreground"
        >
            <Sidebar />
            <main
                data-testid="main-content"
                className="flex-1 min-w-0 overflow-x-hidden"
            >
                <div className={fullWidth ? "w-full max-w-full px-4 md:px-8 py-8" : "max-w-7xl mx-auto px-4 py-8"}>
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
